import React, { Component } from 'react';
import './Roofing.css';
import QuoteForm from '../QuoteForm/QuoteForm';
import StyleCard from '../StyleCards/StyleCard';
import doubleHung from '../../Assets/windowStyles/DoubleHung.jpg';
import awning from '../../Assets/windowStyles/Awning.jpg';
import casement from '../../Assets/windowStyles/Casement.jpg';
import garden from '../../Assets/windowStyles/Garden.jpg';
import picture from '../../Assets/windowStyles/Picture.jpg';
import shape from '../../Assets/windowStyles/Shape.jpg';
import slider from '../../Assets/windowStyles/Slider.jpg';
import bay from '../../Assets/windowStyles/Bay.jpg';
import { BrowserRouter as Router, Routes,Route } from 'react-router-dom';


class Roofing extends Component {
  render() {
  return (
    <div class='windowMain'>
      <div class='roofingHeader'>
        <h1 class="windowTitle">
          Roofing
        </h1>
      </div>
      <div class="visionSect">
         <h2>Roof Replacements</h2>
         <div class="vision">
          Our Vision at DNS Home Exteriors has always been to set a new standard of excellence for contractors that raises the bar when it comes to first-class customer service, industry knowledge, and craftsmanship.
         </div>
      </div>
      <hr></hr>
      <div class="windowInfoSect">
        <section class="windowInfo">
          <div>
          <h4>It's time to replace your Roof</h4>
          <p>Replacing your roof is essential for maintaining the
          structural integrity and safety of your home. Over time,
          roofing materials deteriorate due to exposure to harsh weather
          conditions such as heavy rain, snow, wind, and intense sunlight.
           An aging or damaged roof can lead to leaks, mold growth, and water
           damage inside your home, potentially causing costly repairs.
           A new roof ensures better protection against the elements and
           can improve insulation, helping regulate indoor temperatures and
           reduce energy bills.
          <br></br>
          <br></br>
          In addition to functionality, a new roof can significantly enhance
           your home’s curb appeal and market value. An updated roof adds a
           fresh, clean look and signals to potential buyers that the home is
           well-maintained. Modern roofing materials also come with longer
            warranties and improved durability, making them a smart long-term
            investment. Whether you're planning to sell or stay in your home,
            replacing an old roof provides peace of mind and lasting benefits.</p>
          </div>
        </section>
        <section class="quotoForm">
          <QuoteForm />
        </section>
      </div>
    <div class="sectionSpacer">
    </div>

  </div>
  )
};
}

export default Roofing;
